import {AnswerTemplateDto} from "../domain/dtos";
import {removeDiacritics} from "../../../../../shared/helpers/filter.helper";
import {Company} from "@livechat/shared";

export type AnswerTemplateFilter = {
  templates: Array<AnswerTemplateDto>;
  filters: {
    text?: string;
    company?: string;
  }
};

export function observablesToFilterFormat(
  [templates, text, company]: [Array<AnswerTemplateDto>, string, string | undefined]
): AnswerTemplateFilter {
  return {templates, filters: {text, company}}
}

export function companyFilter(value: AnswerTemplateFilter) {
  if (!value.filters.company) return value;

  value.templates = value.templates.filter((template) =>
    template.companiesIds.includes(value.filters.company || ''));

  return value;
}

export function textFilter(value: AnswerTemplateFilter) {
  if (!value.filters.text) return value;

  value.templates = value.templates.filter((template) => {
    const title = removeDiacritics(template.title.toLowerCase());
    const query = removeDiacritics((value.filters.text || '').toLowerCase());

    return title.includes(query)
  });

  return value;
}

export function buildCompanyDisplay(companies: Array<Company>) {
  return (value: AnswerTemplateFilter) => {
    value.templates.map(template => {
      if (companies?.length === template.companiesIds.length) {
        template.companyNames = 'ALL_COMPANIES_SELECTED';
      } else {
        const names = template.companiesIds

          // Gets all companies related to the template
          .map((companyId) => {
            return companies?.find(c => c.companyId === companyId)
          })

          // Prevents an empty company name from showing up
          .filter(c => !!c?.companyName)

          // Returns only the company name
          .map(c => c?.companyName) as Array<string>;

        // Formats to a readable string
        template.companyNames = names.join(', ');
      }
    })

    return value;
  }
}
